import { Pipe, PipeTransform } from '@angular/core';

/*
 * Receives a number and outputs the same number with the number of truncated decimal places without rounding.
 * We can use the defult pipe 'number' but if we use 'number' pipe will round out.
 * Usage:
 *   value | customDecimalTruncate : {numberOfDigits}
 * Example:
 *   {{ 123.45678 | customDecimalTruncate : 2}}
 *   formats value to : 123.45
 */
@Pipe({
    name: 'customDecimalTruncate',
    standalone: false
})
export class CustomDecimalTruncatePipe implements PipeTransform {
  transform(value: number, digits: number = 2): string {
    if (value) {
      const multiplier = Math.pow(10, digits);
      return (Math.trunc(value * multiplier) / multiplier)
        .toString()
        .replace('.', ',');
    }
  }
}
